import React, { useState } from 'react';
import logo from './lychee.png';
import './App.css';
import { BrowserRouter, Route, Routes, Link } from 'react-router-dom';

import Login from './LoginPage.js';
import Signup from './SignUpPage.js';
import Finder from './Finder.js';
import PasswordReset from './PasswordReset.js';
import Feedback from './FeedbackPage.js';

const App = () => {
  const [hasRestaurant, setHasRestaurant] = useState(false);
  const [resetKey, setResetKey] = useState(0);

  const handleLogoClick = () => {
    setHasRestaurant(false);
    setResetKey(k => k + 1);
  };

  return (
    <div className="wrapper">
      <BrowserRouter>
        <header className="top-app-header">
          <div className="top-left-section"></div>
          <div className="top-right-section">
            <nav>
              <ul>
                <li><Link to="/">Finder</Link></li>
                <li><Link to="/feedback">Feedback</Link></li>
                <li><Link to="/login">Login</Link></li>
              </ul>
            </nav>
          </div>
        </header>
        <header className="logo-app-header">
          <Link to="/" onClick={handleLogoClick}>
            <img src={logo} alt="Lychee Logo" className="logo" />
          </Link>
          <h1 className="title">Láichī</h1>
          {hasRestaurant && <p className="logo-subtitle">Let's find a place to eat</p>}
        </header>
        <Routes>
          <Route path='/forgot-password' element={<PasswordReset />} />
          <Route path='/login' element={<Login />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/feedback' element={<Feedback />} />
          <Route
            path='/'
            element={
              <Finder
                key={resetKey}
                onRestaurantFound={() => setHasRestaurant(true)}
              />
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
